// extracted by mini-css-extract-plugin
export default {"column2":"index_column2_JY-Cw"};